export const COMPANY_INFO = {
  name: "JNO Montage",
  address: "Ribevej 14",
  city: "6670 Holsted",
  fullAddress: "Ribevej 14, 6670 Holsted",
  phone: "(+45) 20 74 34 20",
  phoneRaw: "+4520743420",
  email: "Joenomontage@gmail.com",
  cvr: "30015371",
  findVejUrl: "https://www.google.com/maps/dir/?api=1&destination=Ribevej+14,+6670+Holsted",
  facebookUrl: "https://www.facebook.com/Jnomontage/",
  serviceAreas: ["Holsted", "Vejen", "Esbjerg", "Sydjylland", "Vestjylland"],
  experienceYears: 40,
  logoWhiteUrl: "https://assets.auxodev.dk/assets/b7fb5f15-602f-4c3f-8819-ccd847432aa9/jno-white-logo.svg",
  logoDarkUrl: "https://assets.auxodev.dk/assets/b7fb5f15-602f-4c3f-8819-ccd847432aa9/jno-logo.svg"
};
